(() => {
  if (window.ukfcBoxPricingReady) return;
  window.ukfcBoxPricingReady = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ukfc-add-full-box]');
    if (!button) return;
    const panel = button.closest('.ukfc-box-pricing');
    const boxQuantity = Number(panel?.dataset.boxQuantity);
    if (!Number.isSafeInteger(boxQuantity) || boxQuantity < 2) return;
    const root = button.closest('product-info, .quick-view') || document;
    const form = root.querySelector('#' + CSS.escape(panel.dataset.productFormId || ''));
    const quantity = form?.querySelector('input[name="quantity"]');
    const variant = form?.querySelector('input[name="id"]');
    const submit = form?.querySelector('button[name="add"]');
    if (!quantity || !variant?.value || !submit || submit.disabled) return;
    const min = Number(quantity.min) || 1;
    const max = quantity.max ? Number(quantity.max) : Infinity;
    const step = Number(quantity.step) || 1;
    if (boxQuantity < min || boxQuantity > max || (boxQuantity - min) % step !== 0) return;
    quantity.value = String(boxQuantity);
    quantity.dispatchEvent(new Event('input', { bubbles: true }));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
    form.requestSubmit(submit);
  });
})();
